// extracted by mini-css-extract-plugin
export default {"hiddenScrollbar":"rgGnsQuAg5PQm4i8aZTL","iconRight":"GF643o1K0nlsDU3xUFtV","iconLeft":"mL8PIKnhwgIFmLcjM2br"};